<template>
  <div>
    <!-- 目录类型 (menuType = 1) -->
    <el-submenu v-if="menu.menuType === 1 && hasVisibleChildren" :index="menu.id.toString()">
      <template slot="title">
        <i class="el-icon-folder"></i>
        <span>{{ menu.menuName }}</span>
      </template>
      <menu-item v-for="child in visibleChildren" :key="child.id" :menu="child" @select-menu="$emit('select-menu', $event)" />
    </el-submenu>
    
    <!-- 菜单页面类型 (menuType = 2) -->
    <el-menu-item v-else-if="menu.menuType === 2 && menu.isShow === 1" :class="{'menu-children': menu.parentId !== 0}" :index="menu.id.toString()" @click="handleMenuClick(menu)">
      <template slot="title">
        <i class="el-icon-document"></i>
        <span slot="title">{{ menu.menuName }}</span>
      </template>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    menu: {
      type: Object,
      required: true
    }
  },
  computed: {
    visibleChildren() {
      return this.menu.children ? this.menu.children.filter(child => child.isShow === 1) : []
    },
    hasVisibleChildren() {
      return this.visibleChildren.length > 0
    }
  },
  methods: {
    getMenuPath(menu) {
      // 根据菜单路径生成路由路径
      if (menu.path) {
        // 如果路径已经以 / 开头，直接返回，否则添加 /
        return menu.path.startsWith('/') ? menu.path : `/${menu.path}`
      }
      // 如果没有路径，可以根据菜单名称生成默认路径
      return `/menu/${menu.id}`
    },
    handleMenuClick(menu) {
      const menuItem = {
        name: menu.id.toString(),
        title: menu.menuName,
        path: this.getMenuPath(menu)
      }
      
      // 触发选中事件，让父组件统一处理
      this.$emit('select-menu', menuItem)
    }
  }
}
</script>

<style scoped>
.menu-children {
  padding-left: 20px;
}
</style>